// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaEye, FaEyeSlash, FaUserPlus } from "react-icons/fa";
// import Swal from 'sweetalert2';
// import "./Login.css"; 
// import A2ZLogo from "../../assets/logobgremove.png"; 
// import { API_BASE } from "../../ApiUrl";

// const Login = () => {
//   const navigate = useNavigate();
//   const [identifier, setIdentifier] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);

//   // OTP State variables
//   const [showOTPInput, setShowOTPInput] = useState(false);
//   const [otpCode, setOtpCode] = useState("");
//   const [otpLoading, setOtpLoading] = useState(false);
//   const [otpRequestLoading, setOtpRequestLoading] = useState(false);
//   const [otpTimer, setOtpTimer] = useState(0);
//   const [storedCredentials, setStoredCredentials] = useState({ email: "", password: "" });

//   // Timer for OTP resend
//   useEffect(() => {
//     let interval;
//     if (otpTimer > 0) {
//       interval = setInterval(() => {
//         setOtpTimer((prev) => prev - 1);
//       }, 1000);
//     }
//     return () => clearInterval(interval);
//   }, [otpTimer]);

//   // Handle OTP Request
//   const handleRequestOTP = async (e) => {
//     e.preventDefault();
    
//     // Validate email and password before OTP request
//     if (!identifier.trim() || !password) {
//       setError("Please enter both email and password");
//       return;
//     }

//     setOtpRequestLoading(true);
//     setError("");

//     try {
//       const response = await fetch(`${API_BASE}/otp-request/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           email: identifier.trim(),
//           password: password,
//           otp_type: "LOGIN",
//           tenant: "string" // Super Admin doesn't have a specific tenant
//         }),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message || "Failed to send OTP");
//       }

//       // Store credentials for later login
//       setStoredCredentials({
//         email: identifier.trim(),
//         password: password
//       });

//       // Show OTP input
//       setShowOTPInput(true);
//       setOtpTimer(60); // 60 seconds timer
//       setOtpCode("");

//       await Swal.fire({
//         icon: "success",
//         title: "OTP Sent!",
//         text: "Please check your email for the verification code.",
//         timer: 2000,
//         showConfirmButton: false
//       });

//     } catch (err) {
//       Swal.fire({
//         icon: "error",
//         title: "OTP Request Failed",
//         text: err.message,
//       });
//     } finally {
//       setOtpRequestLoading(false);
//     }
//   };

//   // Handle OTP Verification and Login
//   const handleVerifyOTPAndLogin = async (e) => {
//     e.preventDefault();
    
//     if (!otpCode || otpCode.length !== 6) {
//       setError("Please enter a valid 6-digit OTP");
//       return;
//     }

//     setOtpLoading(true);
//     setError("");

//     try {
//       // First verify OTP
//       const verifyResponse = await fetch(`${API_BASE}/otp-verify/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           email: storedCredentials.email,
//           otp: otpCode,
//           otp_type: "LOGIN",
//           tenant: "string" // Super Admin doesn't have a specific tenant
//         }),
//       });

//       const verifyData = await verifyResponse.json();

//       if (!verifyResponse.ok) {
//         throw new Error(verifyData.message || "Invalid OTP");
//       }

//       // If OTP is verified, proceed with login
//       const loginResponse = await fetch(`${API_BASE}/login/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         credentials: "include",
//         body: JSON.stringify({
//           tenant: "string",
//           email: storedCredentials.email,
//           password: storedCredentials.password,
//         }),
//       });

//       const loginData = await loginResponse.json();

//       if (!loginResponse.ok) {
//         throw new Error(loginData.message || "Login failed");
//       }

//       const role = loginData.role?.[0];

//       if (role === "Super Admin" || role === "Superadmin") {
//         const userData = {
//           id: loginData.user?.id,
//           role: role,
//           full_name:
//             `${loginData.user?.first_name || ""} ${loginData.user?.last_name || ""}`.trim() ||
//             "Super Admin",
//         };

//         localStorage.setItem("super_admin_user", JSON.stringify(userData));

//         await Swal.fire({
//           icon: "success",
//           title: "Login Successful 🎉",
//           timer: 1500,
//           showConfirmButton: false,
//         });

//         navigate("/superadmin/tenants/tenant-table");
//       } else {
//         throw new Error("Access denied. Super Admin privileges required.");
//       }

//     } catch (err) {
//       Swal.fire({
//         icon: "error",
//         title: "Login Failed",
//         text: err.message,
//       });
//     } finally {
//       setOtpLoading(false);
//     }
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   // Resend OTP
//   const handleResendOTP = async () => {
//     if (otpTimer > 0) return;

//     try {
//       const response = await fetch(`${API_BASE}/otp-request/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           email: storedCredentials.email,
//           password: storedCredentials.password,
//           otp_type: "LOGIN",
//           tenant: "string"
//         }),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message || "Failed to resend OTP");
//       }

//       setOtpTimer(60);
//       await Swal.fire({
//         icon: "success",
//         title: "OTP Resent!",
//         text: "Please check your email for the new verification code.",
//         timer: 1500,
//         showConfirmButton: false
//       });

//     } catch (err) {
//       Swal.fire({
//         icon: "error",
//         title: "Failed to Resend OTP",
//         text: err.message,
//       });
//     }
//   };

//   // Main Login View
//   return (
//     <div className="training-admin-login d-flex align-items-center justify-content-center min-vh-100 bg-light">
//       <div className="training-admin-login-card card p-4 shadow" style={{ width: "100%", maxWidth: "400px" }}>
//         <div className="card-body">
//           <div className="training-admin-login-header login-text-center mb-4">
//             <div className="mb-3">
//               <img
//                 src={A2ZLogo}
//                 alt="A2Z Logo"
//                 style={{
//                   width: "80px",
//                   height: "80px",
//                   objectFit: "contain",
//                   margin: "0 auto",
//                   display: "block"
//                 }}
//               />
//             </div>
//             <h3 className="training-admin-login-title" style={{ fontSize: "24px", fontWeight: "600", color: "#333" }}>
//               {showOTPInput ? "Enter Verification Code" : "Super Admin"}
//             </h3>
//             <p className="text-muted" style={{ fontSize: "12px" }}>
//               {showOTPInput ? "Please enter the 6-digit code sent to your email" : "Secure Admin Access"}
//             </p>
//           </div>

//           {error && (
//             <div className="alert alert-danger alert-dismissible fade show" role="alert" style={{ fontSize: "14px" }}>
//               {error}
//               <button type="button" className="btn-close" onClick={() => setError("")}></button>
//             </div>
//           )}

//           {!showOTPInput ? (
//             // Login Form
//             <form onSubmit={handleRequestOTP}>
//               <div className="mb-3">
//                 <label htmlFor="identifier" className="form-label" style={{ fontWeight: "500", fontSize: "14px" }}>
//                   Email <span className="text-danger">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   id="identifier"
//                   placeholder="Enter your email"
//                   value={identifier}
//                   onChange={(e) => setIdentifier(e.target.value)}
//                   required
//                   disabled={otpRequestLoading}
//                   style={{ padding: "12px", fontSize: "14px" }}
//                 />
//               </div>

//               <div className="mb-4">
//                 <label htmlFor="password" className="form-label" style={{ fontWeight: "500", fontSize: "14px" }}>
//                   Password <span className="text-danger">*</span>
//                 </label>
//                 <div className="input-group">
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     className="form-control"
//                     id="password"
//                     placeholder="Enter your password"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     required
//                     disabled={otpRequestLoading}
//                     style={{ padding: "12px", fontSize: "14px" }}
//                   />
//                   <button
//                     type="button"
//                     className="btn btn-outline-secondary"
//                     onClick={togglePasswordVisibility}
//                     disabled={otpRequestLoading}
//                   >
//                     {showPassword ? <FaEyeSlash /> : <FaEye />}
//                   </button>
//                 </div>
//               </div>

//               <div className="d-grid mb-3">
//                 <button
//                   type="submit"
//                   className="btn btn-primary"
//                   disabled={otpRequestLoading}
//                   style={{
//                     padding: "12px",
//                     fontSize: "16px",
//                     fontWeight: "500",
//                     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                     border: "none"
//                   }}
//                 >
//                   {otpRequestLoading ? (
//                     <>
//                       <span className="spinner-border spinner-border-sm me-2"></span>
//                       Sending OTP...
//                     </>
//                   ) : (
//                     'Send OTP'
//                   )}
//                 </button>
//               </div>
//             </form>
//           ) : (
//             // OTP Verification Form
//             <form onSubmit={handleVerifyOTPAndLogin}>
//               <div className="mb-4">
//                 <label htmlFor="otpCode" className="form-label" style={{ fontWeight: "500", fontSize: "14px" }}>
//                   Enter 6-Digit OTP <span className="text-danger">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   id="otpCode"
//                   placeholder="Enter 6-digit code"
//                   value={otpCode}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/\D/g, '').slice(0, 6);
//                     setOtpCode(value);
//                   }}
//                   required
//                   disabled={otpLoading}
//                   style={{ 
//                     padding: "12px", 
//                     fontSize: "20px", 
//                     textAlign: "center",
//                     letterSpacing: "8px",
//                     fontWeight: "bold"
//                   }}
//                   maxLength="6"
//                   pattern="\d{6}"
//                 />
//               </div>

//               <div className="text-center mb-3">
//                 <small className="text-muted">
//                   Didn't receive the code? 
//                   {otpTimer > 0 ? (
//                     <span style={{ marginLeft: "5px" }}>
//                       Resend in {otpTimer}s
//                     </span>
//                   ) : (
//                     <button
//                       type="button"
//                       className="btn btn-link btn-sm"
//                       onClick={handleResendOTP}
//                       style={{ padding: "0", marginLeft: "5px" }}
//                     >
//                       Resend OTP
//                     </button>
//                   )}
//                 </small>
//               </div>

//               <div className="d-grid gap-2">
//                 <button
//                   type="submit"
//                   className="btn btn-primary"
//                   disabled={otpLoading}
//                   style={{
//                     padding: "12px",
//                     fontSize: "16px",
//                     fontWeight: "500",
//                     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                     border: "none"
//                   }}
//                 >
//                   {otpLoading ? (
//                     <>
//                       <span className="spinner-border spinner-border-sm me-2"></span>
//                       Verifying & Logging in...
//                     </>
//                   ) : (
//                     'Verify & Login'
//                   )}
//                 </button>

//                 <button
//                   type="button"
//                   className="btn btn-outline-secondary"
//                   onClick={() => {
//                     setShowOTPInput(false);
//                     setOtpCode("");
//                     setError("");
//                     setOtpTimer(0);
//                   }}
//                   disabled={otpLoading}
//                 >
//                   Back to Login
//                 </button>
//               </div>
//             </form>
//           )}

//           <div className="text-center mt-4">
//             <small className="text-muted">
//               © 2026 Super Admin. All rights reserved.
//             </small>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;



import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash, FaUserPlus } from "react-icons/fa";
import Swal from "sweetalert2";
import "./Login.css";
import A2ZLogo from "../../assets/logobgremove.png";
import { API_BASE } from "../../ApiUrl";

const Login = () => {
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showRegistrationOptions, setShowRegistrationOptions] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          tenant: "string",
          email: identifier.trim(),
          password: password,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Invalid credentials");
      }

      const role = data.role?.[0];

      if (role === "Super Admin" || role === "Superadmin") {
        const userData = {
          id: data.user?.id,
          role: role,
          full_name:
            `${data.user?.first_name || ""} ${data.user?.last_name || ""}`.trim() ||
            "Super Admin",
        };

        localStorage.setItem("super_admin_user", JSON.stringify(userData));

        await Swal.fire({
          icon: "success",
          title: "Login Successful 🎉",
          timer: 1500,
          showConfirmButton: false,
        });

        navigate("/superadmin/tenants/tenant-table");
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: err.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Main Login View
  return (
    <div className="training-admin-login d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <div
        className="training-admin-login-card card p-4 shadow"
        style={{ width: "100%", maxWidth: "400px" }}
      >
        <div className="card-body">
          <div className="training-admin-login-header login-text-center mb-4">
            <div className="mb-3">
              <img
                src={A2ZLogo}
                alt="A2Z Logo"
                style={{
                  width: "80px",
                  height: "80px",
                  objectFit: "contain",
                  margin: "0 auto",
                  display: "block",
                }}
              />
            </div>
            <h3
              className="training-admin-login-title"
              style={{ fontSize: "24px", fontWeight: "600", color: "#333" }}
            >
              Super Admin
            </h3>
          </div>

          {error && (
            <div
              className="alert alert-danger alert-dismissible fade show"
              role="alert"
              style={{ fontSize: "14px" }}
            >
              {error}
              <button
                type="button"
                className="btn-close"
                onClick={() => setError("")}
              ></button>
            </div>
          )}

          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label
                htmlFor="identifier"
                className="form-label"
                style={{ fontWeight: "500", fontSize: "14px" }}
              >
                Email <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="identifier"
                placeholder="Enter your email"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                required
                disabled={loading}
                style={{ padding: "12px", fontSize: "14px" }}
              />
            </div>

            <div className="mb-4">
              <label
                htmlFor="password"
                className="form-label"
                style={{ fontWeight: "500", fontSize: "14px" }}
              >
                Password <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  id="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                  style={{ padding: "12px", fontSize: "14px" }}
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={togglePasswordVisibility}
                  disabled={loading}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            <div className="d-grid mb-3">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
                style={{
                  padding: "12px",
                  fontSize: "16px",
                  fontWeight: "500",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Signing in...
                  </>
                ) : (
                  "Sign In"
                )}
              </button>
            </div>
          </form>

          <div className="text-center mt-4">
            <small className="text-muted">
              © 2026 Super Admin. All rights reserved.
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
